import React from 'react';
import PropTypes from 'prop-types';
import SubmitButton from '../../../atoms/submit-button/index.ts';
import InputLabel from '../../../atoms/inputs/input-label';
import styles from './styles.scss';

const StripeReviewForm = function StripeReviewForm(props) {
    const {
        detailsurl, licenceurl, firstname, lastname, email,
        phonenumber, dateofbirth, address, city, state, postcode,
        licencefront, licenceback,
    } = props;

    const details = [
        { 'First name': firstname },
        { 'Last name': lastname },
        { Email: email },
        { 'Contact number': phonenumber },
        { 'Date of birth': dateofbirth },
        { 'Personal address': address },
        { 'City / Suburb': city },
        { State: state },
        { Postcode: postcode },
    ];

    const detailsEls = details.map((o) => {
        const key = Object.keys(o)[0];
        const value = Object.values(o)[0];
        return (
            <tr key={key}>
                <td className={styles.key}>{key}</td>
                <td className={styles.value}>{value}</td>
            </tr>
        );
    });

    return (
        <div className={styles['stripe-review-form']}>
            <div className={styles['details-review']}>
                <table>
                    <tbody>
                        {detailsEls}
                        <tr>
                            <td colSpan="2">
                                <a className={styles.edit} href={detailsurl}>Edit</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className={styles['licence-review']}>
                <div>
                    <InputLabel>Driver&apos;s Licence (front)</InputLabel>
                    <br />
                    <img src={licencefront} style={{ maxHeight: '140px' }} alt="Front of the drivers licence that was uploaded" />
                </div>
                <div>
                    <InputLabel>Driver&apos;s Licence (back)</InputLabel>
                    <br />
                    <img src={licenceback} style={{ maxHeight: '140px' }} alt="Back of the drivers licence that was uploaded" />
                </div>
                <a className={styles.edit} href={licenceurl}>Edit</a>
            </div>

            <form action="Review" method="post" className={styles['licence-upload-form']}>
                <SubmitButton name="review-submit" />
            </form>
        </div>
    );
};

StripeReviewForm.propTypes = {
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phonenumber: PropTypes.string.isRequired,
    dateofbirth: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    licencefront: PropTypes.string.isRequired,
    licenceback: PropTypes.string.isRequired,
    detailsurl: PropTypes.string.isRequired,
    licenceurl: PropTypes.string.isRequired,
};

export default StripeReviewForm;
